import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../home/components/TrustBar';
import WhyChooseUs from '../home/components/WhyChooseUs';
import Testimonials from '../home/components/Testimonials';
import ProcessTimeline from '../home/components/ProcessTimeline';
import MidCTA from '../home/components/MidCTA';
import Gallery from '../home/components/Gallery';
import LeadForm from '../home/components/LeadForm';
import MobileCallButton from '../home/components/MobileCallButton';
import LocationsHero from './components/LocationsHero';
import LocationsServices from './components/LocationsServices';
import LocationsFAQ from './components/LocationsFAQ';

export default function LocationsPage() {
  return (
    <main>
      <Navbar />
      <LocationsHero />
      <TrustBar />
      <LocationsServices />
      <WhyChooseUs />
      <Testimonials />
      <MidCTA />
      <ProcessTimeline />
      <LocationsFAQ />
      <Gallery />
      <LeadForm />
      <Footer />
      <MobileCallButton />
    </main>
  );
}
